import { rem } from "@mantine/core";
import type { MantineSpacing } from "../mantine";

export const spacing: Record<MantineSpacing, string> = {
    xxs: rem(2),
    xs: rem(4),
    sm: rem(8),
    md: rem(12),
    lg: rem(16),
    lg2: rem(20),
    xl: rem(24),
    xxl: rem(32),
};
